/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Bu dosya QubePro ekosisteminde ortak (global) standarttır.
 * Tek kaynak `qubepro-core` reposudur; uydu repolarda kalıcı değişiklik yapılmaz.
 * Değişiklik gerekiyorsa Core'da güncellenir ve senkron ile diğer repolara yayılır.
 */

import React from 'react';
import './Loading.css';

interface LoadingProps {
    fullScreen?: boolean;
    size?: 'small' | 'medium' | 'large';
    message?: string;
}

export const Loading: React.FC<LoadingProps> = ({ fullScreen = false, size = 'medium', message }) => {
    return (
        <div className={`loading-container ${fullScreen ? 'fullscreen' : ''}`}>
            <div className={`spinner ${size}`}></div>
            {message && <div className="loading-message">{message}</div>}
        </div>
    );
};
